import { getWorkspace } from '../session/sessionStorage'
import { useTranslation } from 'react-i18next'

export const useServiceOrderNonComplianceInterpolationsFetcher = skip => {
  const { t } = useTranslation('serviceOrders')
  const workspace = getWorkspace()

  if (skip) return []

  return [
    {
      name: t('interpolations.activityCode'),
      id: '{{non_compliance_event.service_order.yearly_id}}',
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.activityName'),
      id: '{{non_compliance_event.service_order.name}}',
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.activityDescription'),
      id: '{{non_compliance_event.service_order.description}}',
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.checklistName'),
      id: '{{non_compliance_event.service_order.checklist.name}}',
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.status'),
      id: '{{non_compliance_event.service_order.status.name}}',
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.placeName'),
      id: '{{non_compliance_event.service_order.place.name}}',
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.publicResumeLink'),
      id: `https://${workspace}.btime.io/resume/{{non_compliance_event.service_order.id}}?t={{non_compliance_event.service_order.resume_token}}`,
      type: 'string',
      group: t('interpolations.groups.activity')
    },
    {
      name: t('interpolations.publicExecutionLink'),
      id: `https://${workspace}.btime.io/service-orders/{{non_compliance_event.service_order.id}}/execution?t={{non_compliance_event.service_order.execution_token}}`,
      type: 'string',
      group: t('interpolations.groups.activity')
    },

    {
      name: t('interpolations.userName'),
      id: '{{anonymous non_compliance_event.service_order.user.name}}',
      type: 'string',
      group: t('interpolations.groups.user')
    },
    {
      name: t('interpolations.userEmail'),
      id: '{{non_compliance_event.service_order.user.email}}',
      type: 'string',
      group: t('interpolations.groups.user')
    },

    {
      name: t('interpolations.destinationName'),
      id: '{{non_compliance_event.service_order.place.name}}',
      type: 'string',
      group: t('interpolations.groups.destination')
    },
    {
      name: t('interpolations.fullDestinationName'),
      id: '{{non_compliance_event.service_order.place.resume}} - {{non_compliance_event.service_order.place.name}}',
      type: 'string',
      group: t('interpolations.groups.destination')
    },

    {
      name: t('interpolations.schedulingDate'),
      id: '{{non_compliance_event.service_order.scheduling}}',
      type: 'datetime',
      group: t('interpolations.groups.dates')
    },
    {
      name: t('interpolations.openingDate'),
      id: '{{non_compliance_event.service_order.start_date}}',
      type: 'datetime',
      group: t('interpolations.groups.dates')
    },
    {
      name: t('interpolations.completionDate'),
      id: '{{non_compliance_event.service_order.end_date}}',
      type: 'datetime',
      group: t('interpolations.groups.dates')
    }
  ]
}

export const useServiceOrderNonComplianceRawInterpolationsFetcher = skip => {
  const { t } = useTranslation('serviceOrders')
  if (skip) return []

  return [
    {
      name: t('interpolations.savedActivityUser'),
      id: '::{{non_compliance_event.service_order.user_id}}',
      type: 'raw_user'
    },

    {
      name: t('interpolations.updatedNonCompliancePlace'),
      id: '::{{non_compliance_event.service_order.place_id}}',
      type: 'raw_place'
    },

    {
      name: t('interpolations.updatedNonComplianceAsset'),
      id: '::{{non_compliance_event.service_order.asset_id}}',
      type: 'raw_asset'
    },

    {
      name: t('interpolations.savedActivityChecklist'),
      id: '::{{non_compliance_event.service_order.checklist_id}}',
      type: 'raw_checklist'
    },

    {
      name: t('interpolations.schedulingDate'),
      id: '::{{non_compliance_event.service_order.scheduling}}',
      type: 'raw_datetime',
      group: t('interpolations.groups.dates')
    },
    {
      name: t('interpolations.openingDate'),
      id: '::{{non_compliance_event.service_order.start_date}}',
      type: 'raw_datetime',
      group: t('interpolations.groups.dates')
    },
    {
      name: t('interpolations.completionDate'),
      id: '::{{non_compliance_event.service_order.end_date}}',
      type: 'raw_datetime',
      group: t('interpolations.groups.dates')
    }
  ]
}
